import React from 'react'
import { Password } from 'primereact/password'

export default function LtsPassword(props) {
  const onChange = (event) => {
    const target = event.target
    props.onChange(target.value)
  }

  const resolveLabel = () => {
    if (props.label && !props.hidden) {
      return <label>{props.label}</label>
    }
    return null
  }

  return (
    <React.Fragment>
      <span className="p-float-label">
        <Password
          {...props}
          value={props.value}
          onChange={onChange}
          name={props.name}
          autoFocus={props.autoFocus}
          style={props.style}
          disabled={props.disabled}
          inputId={props.inputId}
          inputRef={props.inputRef}
          inputStyle={props.inputStyle}
          inputClassName={props.inputClassName}
          feedback={props.feedback !== undefined ? props.feedback : true}
          toggleMask={props.toggleMask !== undefined ? props.toggleMask : false}
          promptLabel={props.promptLabel}
          weakLabel={props.weakLabel}
          mediumLabel={props.mediumLabel}
          strongLabel={props.strongLabel}
          mediumRegex={props.mediumRegex}
          strongRegex={props.strongRegex}
          keyfilter={props.keyfilter}
          tooltip={props.tooltip}
          tooltipOptions={props.tooltipOptions}
          panelStyle={props.panelStyle}
          panelClassName={props.panelClassName}
        />
        {resolveLabel()}
      </span>
    </React.Fragment>
  )
}
